/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Switch, Route, useParams } from 'react-router-dom';
import { companyTrackerInitiativeRoutes } from './CompanyTrackerInitiativeRoute';
import { CustomDashboard } from '../custom-dashboard';
import Summary from '../summary';
import { StaticDashboardRoute } from '../summary/staff-only/StaticDashboardRoute';
import { useAppSelector } from '../../reducers';
import { canUseStaticCustomDashboards } from '../../selectors/initiative';


export const InsightRoute = () => {

  const { dashboardId } = useParams<{ dashboardId?: string }>();
  const canUseStaticESG = useAppSelector(canUseStaticCustomDashboards);


  // Start routing to the new static (ESG) automatically
  const paths = canUseStaticESG?  [
    companyTrackerInitiativeRoutes.SUMMARY_STAFF_ONLY.path,
    companyTrackerInitiativeRoutes.SUMMARY.path
  ] : [companyTrackerInitiativeRoutes.SUMMARY_STAFF_ONLY.path];

  return (
    <Switch>
      <Route path={paths}>
        <StaticDashboardRoute />
      </Route>

      <Route path={companyTrackerInitiativeRoutes.CUSTOM_DASHBOARD.path}>
        <CustomDashboard key={dashboardId} />
      </Route>

      <Route>
        <Summary readOnly={false} />
      </Route>
    </Switch>
  );
};
